import React, { useContext } from 'react';
import LoadingSpinner from '../../ClubRegistrationLoadingSpinner/ClubRegistrationLoadingSpinner';
import { LocalizationContext } from '../../../context/localizationContext';
import Styles from './Searching.module.scss';

const Searching = (props) => {
  const { serialSearched } = props;
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { search } = localizationState.localization;

  return (
    <div className={Styles.searchContainer}>
      <div className={Styles.searchHeader}>{search.searching}</div>
      <LoadingSpinner />
      <div>
        {search.locating} "{serialSearched}"
      </div>
    </div>
  );
};

export default Searching;
